import Absolute from "public/customerLogos/absolute.png";
import Airtel from "public/customerLogos/airtel.png";
import Amadeus from "public/customerLogos/amadeus.png";
import CoveredCalifornia from "public/customerLogos/covered_california.png";
import Helpage from "public/customerLogos/helpag.png";
import Hpe from "public/customerLogos/hpe.png";
import HuntingtonBank from "public/customerLogos/huntingtonbank.png";
import HurricaneElectric from "public/customerLogos/hurricane_electric.png";
import Italtel from "public/customerLogos/italtel.png";
import Mgic from "public/customerLogos/mgic.png";
import Nintendo from "public/customerLogos/nintendo.png";
import Nsc from "public/customerLogos/nsc.png";
import Ntt from "public/customerLogos/ntt.png";
import OnxCanada from "public/customerLogos/onxcanada.png";
import Opentext from "public/customerLogos/opentext.png";
import Sdaia from "public/customerLogos/sdaia.png";
import Shi from "public/customerLogos/shi.png";
import Shu from "public/customerLogos/shu.png";
import SoftwareOne from "public/customerLogos/softwareone.png";
import TeConnectivity from "public/customerLogos/te_connectivity.png";
import Toyota from "public/customerLogos/toyota.png";
import Uroclear from "public/customerLogos/uroclear.png";
import XcelEnergy from "public/customerLogos/xcelenergy.png";

export const CUSTOMER_CONSTANTS = {
  TITLE: "Our Customers: Global Enterprises Trust OneMind Services ",
};

export const CUSTOMERS_LIST = [
  Absolute,
  Airtel,
  Amadeus,
  CoveredCalifornia,
  Helpage,
  Hpe,
  HuntingtonBank,
  HurricaneElectric,
  Italtel,
  Mgic,
  Nintendo,
  Nsc,
  Ntt,
  OnxCanada,
  Opentext,
  Sdaia,
  Shi,
  Shu,
  SoftwareOne,
  TeConnectivity,
  Toyota,
  Uroclear,
  XcelEnergy,
];
